import FiltersPanel from './components/FiltersPanel';

export default FiltersPanel;
